module.exports = __webpack_public_path__ + "static/Background-scot-2.9cc849e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Background-scot-2.jpg
// module id = 475
// module chunks = 153228935106781